// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getSupportedLanguages = contextConfiguration => axios.get(
	'/languages?active=I20211012084452914833',				// I20211012084452914833"  = Ja
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getSupportedLanguages;
